module.exports = __webpack_public_path__ + "img/Dubai.fce95d49.png";